// Clone the selected source graph under the new id map, preserving positional
// branch slots (nulling out edges that point outside the selection). Branch
// positions are NOT compacted — an ifElse's [thenHead, elseHead] shape is kept.
export const buildRemappedGraph = ({ actionIds, sourceGraph, idMap }) => {
  const graph = {};
  for (const currentId of actionIds) {
    const newCurrentId = idMap[currentId];
    const originalNode = sourceGraph[currentId];

    graph[newCurrentId] = {
      exit: originalNode?.exit && idMap[originalNode.exit] ? idMap[originalNode.exit] : null,
      child: originalNode?.child && idMap[originalNode.child] ? idMap[originalNode.child] : null,
      branches: Array.isArray(originalNode?.branches) ? originalNode.branches.map((branchId) => (branchId && idMap[branchId] ? idMap[branchId] : null)) : []
    };
  }

  return graph;
};
